import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTasks = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 25, viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 22.5C6.47715 22.5 2 18.0228 2 12.5C2 6.97715 6.47715 2.5 12 2.5C17.5228 2.5 22 6.97715 22 12.5C22 18.0228 17.5228 22.5 12 22.5ZM12 20.5C16.4183 20.5 20 16.9183 20 12.5C20 8.08172 16.4183 4.5 12 4.5C7.58172 4.5 4 8.08172 4 12.5C4 16.9183 7.58172 20.5 12 20.5ZM11.0026 16.5L6.75999 12.2574L8.17421 10.8431L11.0026 13.6716L16.6595 8.01472L18.0737 9.42893L11.0026 16.5Z", fill: "#CCCCCC" }));
const ForwardRef = forwardRef(SvgTasks);
const Memo = memo(ForwardRef);
export default Memo;
